import { cloneDeep } from "lodash-es";
import { FITDATAIDS } from "../fitData/consts";
import { getRealResponseSchema } from "../common/schemaUtil";
export function getAnyDataSchema() {
  const {
    isSingleRequest,
    cgiName
  } = getAnyRealCgiInfo(this);
  const entitySchema = isSingleRequest && cgiName !== 'request' ? getResponseDataSchema(this, cgiName) : this.getEntitySchema();
  const schema = entitySchema ? cloneDeep(entitySchema) : {
    type: 'any'
  };
  schema.id = 'data';
  schema.title = '响应data';
  schema['ds:fitDataId'] = FITDATAIDS.anyData;
  return schema;
}
export function getAnyRealCgiInfo(state) {
  const config = state.options.sourceConfig;
  const isSingleRequest = !!(config !== null && config !== void 0 && config.anyRequestCgi);
  return {
    isSingleRequest,
    cgiName: (config === null || config === void 0 ? void 0 : config.anyRequestCgi) || 'request'
  };
}
function getResponseDataSchema(state, cgiName) {
  const info = state.collection.collectionData.cgiInfo[cgiName];
  const schema = getRealResponseSchema(info);
  return schema;
}
export function getParamSchema(state, cgiName, id) {
  var _paramsSchema$fields;
  const paramsSchema = state.getCgiParamSchema(cgiName);
  const schema = (_paramsSchema$fields = paramsSchema.fields) === null || _paramsSchema$fields === void 0 ? void 0 : _paramsSchema$fields.find(item => item.id === id);
  return schema;
}
export function getAnyStateFeatures(state) {
  var _state$options$source;
  const configVersion = Number((_state$options$source = state.options.sourceConfig) === null || _state$options$source === void 0 ? void 0 : _state$options$source.configVersion) || 1;
  return {
    hostRequestParams: configVersion >= 2
  };
}
//# sourceMappingURL=any.js.map
